<template>
<div>
    <Header v-if="pctop"></Header>
        <div class="shop-container">
            <swiper-small v-if="pctop" :list="bannerArr" />
            <jshop :pageData="pageData" />
        </div>
    <Footer v-if="pcbottom"></Footer>
    
</div>
   
</template>

<script>
import jshop from "@/components/jshop/jshop";
import SwiperSmall from '@/components/common/SwiperSmall.vue'
import Header from '@/components/common/Header.vue'

import Footer from '@/components/common/Footer.vue'



export default {
    components : {jshop, SwiperSmall, Header, Footer},
    data() {
        return {
            pageCode: 'pc_custom2',
            pageData: [],
            bannerArr: [],
            pctop: false,
            pcbottom: false,
            banner: 'pc_video_home_slide'

        }
    },
    created() {
        if(this.$route.query.code) {
            this.pageCode = this.$route.query.code
        } else {
            this.$message({
                message: "参数缺失",
                type: 'error'

            })
        }

        if(this.$route.query.banner) {
            this.banner = this.$route.query.banner
        }
        
        this.getPageCode()
        this.getBanner()
    },
    methods: {

         // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: this.banner
            }).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },


        getPageCode() {
            const _this = this
            this.$api.getPageConfig({code: this.pageCode}).then(res => {
					if (res.status) {
                        let items = res.data.items

                        console.log(items)
                        let copypcgoodsObj = {}
                        let pcGoodsIndex = 0
                        let firstpcGoods = 0

                        for(let j in items) {
                            if(items[j].widget_code == "pcgoods") {
                                pcGoodsIndex ++
                                if(pcGoodsIndex == 1) {
                                    firstpcGoods = j
                                } else {
                                    items[firstpcGoods].params.list.push(...items[j].params.list)
                                    delete items[j]
                                }
                            }
                        }

                        console.log(items)

                        let arr = []
                        for(let i in items) {
                            let code = items[i].widget_code
                            if(code == "pctop" || code == "pcbottom") {
                                if(code == "pctop" ) {
                                    _this.pctop = true
                                }

                                if(code == "pcbottom" ) {
                                    _this.pcbottom = true
                                }
                            }else {
                                arr.push(items[i])
                            }
                        }


						_this.pageData = arr;
						_this.share_name = res.data.name;
					}
				}
			);
        }
    }
}
</script>

<style >
.shop-container{
    background: #fff;
}
</style>